



import Page from '../PostSales/sale/PostSale.vue'
export default {
  name: 'postsaleRD',
  components: { Page },
}
